export enum TextUsStages {
    ContactData = "contact-data",
    ThankYouWorkDays = "thank-you-work-days",
    ThankYouWeekend = "thank-you-weekend",
}

export type ThankYouStages = TextUsStages.ThankYouWorkDays | TextUsStages.ThankYouWeekend;

export enum OrderAgreementStages {
    Confirm = "confirm",
    Sign = "sign",
}

export enum ModalErrorTypes {
    NOT_ALLOWED = "NOT_ALLOWED"
}
